import { MarketCountryCode } from '@axo/shared/types';
import { rootKeys } from './rootKeys';

export const brandKeys = {
  root: () => [...rootKeys.brands()] as const,
  allBrands: (marketCountry?: MarketCountryCode) =>
    [...brandKeys.root(), 'brands', marketCountry] as const,
  brand: (brandName?: string, marketCountry?: MarketCountryCode) =>
    [...brandKeys.root(), 'brand', marketCountry, brandName] as const,
};
